import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchEmailTemplates = async () => {
  const response = await api.get(`/emailTemplates`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.email-templates') }));
  }

  return response.data;
};

export const fetchEmailTemplateById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/emailTemplates/${id}`);

  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.email-template') }));
  }
  return response.data;
};

export const createEmailTemplate = async (data: unknown) => {
  const response = await api.post(`/emailTemplates`, data);

  if (!response) {
    toast.error(i18n.t('error.api.post-item', { item: i18n.t('module.email-template') }));
  }

  return response.data;
};

export const updateEmailTemplate = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/emailTemplates`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.email-template') }));
  }

  return true;
};

export const deleteEmailTemplate = async (params: { ids: number[] }) => {
  const response = await api.delete(`/emailTemplates`, { data: params });
  if (!response) {
    toast.error(i18n.t('error.api.delete-item', { item: i18n.t('module.email-template') }));
  }
  return true;
};
